<div [className]="!((automationList$ | async) && (automationList$ | async).length) ? 'bmc-automation-anywhere__hidden' : 'bmc-automation-anywhere'">
  <bots-list class="bmc-automation-anywhere__left-side-component" [botsList]="(automationList$ | async)"
    (selectedBotChanged)="onSelectedBotChanged($event)" [isLoading]="(isLoading$ | async)" #botsList></bots-list>
  <automation-detail-wrapper
    [ngClass]="{'bmc-automation-anywhere__hidden': !((automationList$ | async) && (automationList$ | async).length) }" #automationDetailWrapper>
  </automation-detail-wrapper>
</div>
<bots-empty *ngIf="(!(automationList$ | async) || !(automationList$ | async).length) && !(isLoading$ | async)">
  {{'RPA_BOTS.EMPTY' | translate}}
</bots-empty>
